// Mimi's original robot mascot — a cute hand-drawn SVG (no third-party character).
export const MimiRobot = ({ size = 24, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="mimi-head" x1="10" y1="14" x2="54" y2="52" gradientUnits="userSpaceOnUse">
        <stop stopColor="rgb(var(--gold-light))" />
        <stop offset="1" stopColor="rgb(var(--gold))" />
      </linearGradient>
    </defs>
    {/* antenna with glow tip */}
    <line x1="32" y1="6" x2="32" y2="15" stroke="rgb(var(--gold))" strokeWidth="3" strokeLinecap="round" />
    <circle cx="32" cy="5" r="3.5" fill="rgb(var(--gold-light))" />
    {/* ears */}
    <rect x="5" y="27" width="7" height="14" rx="3.5" fill="rgb(var(--gold-dark))" />
    <rect x="52" y="27" width="7" height="14" rx="3.5" fill="rgb(var(--gold-dark))" />
    {/* head */}
    <rect x="10" y="14" width="44" height="40" rx="17" fill="url(#mimi-head)" />
    {/* face plate */}
    <rect x="16" y="22" width="32" height="25" rx="12.5" fill="rgb(var(--panel))" />
    {/* eyes */}
    <circle cx="25.5" cy="32.5" r="4.4" fill="rgb(var(--gold-light))" />
    <circle cx="38.5" cy="32.5" r="4.4" fill="rgb(var(--gold-light))" />
    <circle cx="27" cy="31.2" r="1.5" fill="#fff" />
    <circle cx="40" cy="31.2" r="1.5" fill="#fff" />
    {/* smile */}
    <path d="M26 39.5 q6 5.5 12 0" stroke="rgb(var(--gold-light))" strokeWidth="2.4" strokeLinecap="round" fill="none" />
    {/* blush */}
    <circle cx="19.5" cy="38" r="2" fill="rgb(var(--gold))" opacity="0.55" />
    <circle cx="44.5" cy="38" r="2" fill="rgb(var(--gold))" opacity="0.55" />
  </svg>
);
